import Swiper from 'swiper';
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';
import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const hideElements = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const staggerElements = activeSlide.querySelectorAll('.js-hero-stagger');
    const gradientElements = activeSlide.querySelectorAll('.js-hero-gradient');

    if (staggerElements.length === 0 || gradientElements.length === 0) {
      return;
    }

    gsap.set([...staggerElements, ...gradientElements], { autoAlpha: 0 });
  };

  const playSlideAnimation = (swiper) => {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const staggerElements = activeSlide.querySelectorAll('.js-hero-stagger');
    const gradientElements = activeSlide.querySelectorAll('.js-hero-gradient');

    if (staggerElements.length === 0 || gradientElements.length === 0) {
      return;
    }

    gsap.fromTo(
      gradientElements,
      {
        autoAlpha: 0,
      },
      {
        autoAlpha: 1,
        duration: 1,
        ease: 'power2.out',
        onComplete: () => {
          gsap.fromTo(
            staggerElements,
            {
              autoAlpha: 0,
              y: 50,
            },
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              stagger: 0.25,
              ease: 'power2.out',
            },
          );
        },
      },
    );
  };

  const heroSlider = new Swiper('.js-hero-slider', {
    modules: [EffectFade, Pagination, Navigation, Autoplay],
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 5000,
    },
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.js-hero-slider-pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.js-hero-slider-prev',
      nextEl: '.js-hero-slider-next',
    },
  });

  heroSlider.on('slideChangeTransitionStart', (swiper) => {
    hideElements(swiper);
  });

  heroSlider.on('slideChangeTransitionEnd', (swiper) => {
    playSlideAnimation(swiper);
  });

  heroSlider.init();
});
